/* unplugin-vue-components disabled */import script from "./MyBusiness.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyBusiness.vue?vue&type=script&setup=true&lang=ts"

import "./MyBusiness.vue?vue&type=style&index=0&id=05b60c90&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05b60c90"]])

export default __exports__